import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/payments/rent-object-bookings/${formData.rentObjectBookingId}`, formData);
  },
  async findAll(formData) {
    return axios.get(`/payments/rent-object-bookings/${formData.rentObjectBookingId}`);
  },
  async update(formData) {
    return axios.put(`/payments/${formData.id}`, formData);
  },
  async delete({ id }) {
    return axios.delete(`/payments/${id}`);
  },
};